// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loadingSpinner__wrapper","loading":"loadingSpinner__loading","spin":"loadingSpinner__spin","copy":"loadingSpinner__copy"};